import React from "react";
import { Helmet } from "react-helmet"; // ✅ Import Helmet
import "./ProfessionalExperience.css";
const ProfessionalExperience = () => {
  const physicianExperienceSchema = {
    "@context": "https://schema.org",
    "@type": "Physician",
    "name": "Dr. B. Shruti Sagar", 
    "image": "https://i.ibb.co/5WT8b5SL/doc-sagar-1.png",
    "jobTitle": "Consultant, Department of Gastroenterology",
    "worksFor": {
      "@type": "Hospital",
      "name": "Yashoda Hospitals, Secunderabad",
      "startDate": "2022-10"
    },
    "alumniOf": [
      {
        "@type": "CollegeOrUniversity",
        "name": "M.S. Ramaiah Medical College & Hospital, Bangalore"
      }
    ],
    "description": "Dr. Sagar has extensive experience, including performing over 500 ERCP and 300 EUS procedures. Her career includes roles as a Senior Resident in Gastroenterology and a Resident in Internal Medicine."
  };
  return (
    <>
      {/* SEO Schema added to the page's head */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(physicianExperienceSchema)}
        </script>
      </Helmet>
      <section className="experience-section">
        <h2 className="experience-title">Professional Experience</h2>
        {/* Job 1 */}
        <div className="experience-job">
          <div className="experience-header">
            <img
              src="https://i.ibb.co/zTxdX5g8/image-10-1.png" // Yashoda logo
              alt="Yashoda Hospitals - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
              className="experience-logo"
            />
            <div>
              <p className="experience-role">
                Consultant, Department of Gastroenterology
              </p>
              <p className="experience-hospital">
                Yashoda Hospitals, Secunderabad |{" "}
                <span className="experience-duration">
                  October 2022 - Present
                </span>
              </p>
            </div>
          </div>
          <div className="experience-details">
            <div className="experience-points">
              <ul>
                <li>Performed 500+ advanced ERCP procedures without supervision</li>
                <li>Completed 300+ diagnostic and therapeutic EUS procedures</li>
                <li>
                  Training GI fellows and endoscopic technicians in advanced
                  procedures
                </li>
                <li>
                  Active contributor to gastroenterology research and publications
                </li>
              </ul>
            </div>
            <div className="experience-doctor">
              <img
                src="https://i.ibb.co/5WT8b5SL/doc-sagar-1.png" // Doctor image
                alt="Doctor B. Shruti Sagar - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
              />
            </div>
          </div>
        </div>
        {/* Job 2 */}
        <div className="experience-card red-card">
          <img
            src="https://i.ibb.co/rKgCvkbd/image-19-2.png" // Ramaiah logo
            alt="Ramaiah Institute - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            className="experience-card-logo"
          />
          <div>
            <p className="experience-card-role">
              Senior Resident, Gastroenterology & Hepatology
            </p>
            <p className="experience-card-hospital">
              M.S. Ramaiah Medical College & Hospital, Bangalore |{" "}
              <span className="experience-duration">2019-2022</span>
            </p>
          </div>
        </div>
        {/* Job 3 */}
        <div className="experience-card red-card">
          <img
            src="https://i.ibb.co/rKgCvkbd/image-19-2.png" // Ramaiah logo
            alt="Ramaiah- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            className="experience-card-logo"
          />
          <div>
            <p className="experience-card-role">Resident, Internal Medicine</p>
            <p className="experience-card-hospital">
              M.S. Ramaiah Medical College & Hospital, Bangalore |{" "}
              <span className="experience-duration">2016-2019</span>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default ProfessionalExperience;